import { GET_ORGANIZATION_DATA } from "../../api/Actions/ServiceOrganization";

let initialState = {
  GetOrganizationData: false,
  errorGetOrganizationData: false,
};

export const Organization = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATION_DATA:
      return {
        ...state,
        GetOrganizationData: action.payload.data,
        errorGetOrganizationData: action.payload.errorMessage,
      };
    default:
      return state;
  }
};
